import { motion } from "framer-motion";
import { Wrench, Plug, Sun, ArrowUpRight } from "lucide-react";
import { fadeUp, SectionLabel } from "./shared";

// Custom pipes icon - L-shaped elbow pipe with double walls
const Pipes = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={1.6}
        strokeLinecap="round"
        strokeLinejoin="round"
        {...props}
    >
        {/* Outer pipe wall - L bend */}
        <path d="M3 6h11a4 4 0 0 1 4 4v11" />
        {/* Inner pipe wall - L bend */}
        <path d="M3 10h11" />
        <path d="M14 21v-7" />
        {/* Left flange / opening */}
        <line x1="3" y1="4" x2="3" y2="12" />
        {/* Bottom flange / opening */}
        <line x1="12" y1="21" x2="20" y2="21" />
        {/* Joint / bolt detail */}
        <circle cx="6" cy="8" r="0.7" fill="currentColor" />
        <circle cx="16" cy="18" r="0.7" fill="currentColor" />
    </svg>
);

const services = [
    {
        icon: Wrench,
        title: "Teljes körű lakásfelújítás",
        desc: "A bontási munkálatoktól a végső átadásig egy kézben tartjuk a teljes kivitelezési folyamatot. Korszerű megoldásokkal, pontos ütemezéssel és minőségi kivitelezéssel valósítjuk meg elképzeléseit.",
        image: "/images/service_renovation.png",
    },
    {
        icon: Pipes,
        title: "Gépészeti munkálatok",
        desc: "Víz-, csatorna-, fűtési és egyéb épületgépészeti rendszerek kiépítése, korszerűsítése és felújítása. Energiatakarékos és hosszú távon megbízható megoldásokat kínálunk.",
        image: "/images/service_hvac.png",
    },
    {
        icon: Plug,
        title: "Villanyszerelés",
        desc: "Teljes elektromos hálózatok kiépítése, felújítása és bővítése. Modern, biztonságos és szabványos villamos rendszereket alakítunk ki lakó- és üzleti ingatlanokban.",
        image: "/images/service_electrical.png",
    },
    {
        icon: Sun,
        title: "Napelem szerelés",
        desc: "Napelemes rendszerek tervezése és kivitelezése a fenntartható energiafelhasználás érdekében. Segítünk csökkenteni energiafogyasztását és hosszú távú költségeit.",
        image: "/images/solar.png",
    },
];

export const Services = () => (
    <section
        id="szolgaltatasok"
        data-testid="services-section"
        className="relative bg-white py-24 sm:py-32 border-b border-black/10"
    >
        <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
            <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-8 mb-16">
                <motion.div
                    variants={fadeUp}
                    initial="hidden"
                    whileInView="show"
                    viewport={{ once: true, margin: "-100px" }}
                >
                    <SectionLabel num="03" label="Szolgáltatások" />
                    <h2 className="mt-6 font-display font-extrabold text-4xl sm:text-5xl lg:text-6xl leading-[1.05]">
                        Kulcsrakész kivitelezés,
                        <br />
                        <span className="text-[#0D7A73]">egy helyen.</span>
                    </h2>
                </motion.div>
                
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-black/10 border border-black/10">
                {services.map((s, i) => {
                    const Icon = s.icon;
                    return (
                        <motion.a
                            href="#kapcsolat"
                            key={s.title}
                            variants={fadeUp}
                            custom={i}
                            initial="hidden"
                            whileInView="show"
                            viewport={{ once: true, margin: "-80px" }}
                            data-testid={`service-card-${s.title}`}
                            className="group relative p-8 sm:p-10 flex flex-col gap-6 min-h-[420px] bg-[#0A0A0A] text-white overflow-hidden"
                        >
                            <div
                                className="absolute inset-0 opacity-30 bg-cover bg-center pointer-events-none transition-all duration-700 group-hover:opacity-45 group-hover:scale-105"
                                style={{ backgroundImage: `url(${s.image})` }}
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] via-[#0A0A0A]/85 to-[#0A0A0A]/40 pointer-events-none" />

                            <div className="relative z-10 flex items-start justify-between">
                                <div className="w-14 h-14 flex items-center justify-center bg-[#0D7A73] transition-colors duration-300 group-hover:bg-white">
                                    <Icon
                                        strokeWidth={1.8}
                                        className="w-7 h-7 text-white transition-colors duration-300 group-hover:text-[#0D7A73]"
                                    />
                                </div>
                                <ArrowUpRight className="cta-arrow w-6 h-6 text-[#7ED4CE]" strokeWidth={2} />
                            </div>

                            <div className="relative z-10">
                                
                                <h3 className="mt-3 font-display font-bold text-2xl sm:text-[26px] leading-tight">
                                    {s.title}
                                </h3>
                                <p className="mt-4 leading-relaxed text-[15px] text-white/80">
                                    {s.desc}
                                </p>
                            </div>
                        </motion.a>
                    );
                })}
            </div>
        </div>
    </section>
);
